module.exports = "/_next/static/images/OgPrivacyPortal-4d5557675507ee61ced650dbc1fc4a8a.png";